export interface CacheEntryOptions {
    hash?: string;
    absoluteExpiration?: number;
}
